"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get BOOKING_WARNING_CODES () {
        return _bookingwarnings.BOOKING_WARNING_CODES;
    },
    get BRANCH_HOLIDAY_EXISTS () {
        return _cliniccalendarerrors.BRANCH_HOLIDAY_EXISTS;
    },
    get BRANCH_HOLIDAY_IN_PAST () {
        return _cliniccalendarerrors.BRANCH_HOLIDAY_IN_PAST;
    },
    get BRANCH_HOLIDAY_LIST_MAX_RANGE_YEARS () {
        return _branchholidays.BRANCH_HOLIDAY_LIST_MAX_RANGE_YEARS;
    },
    get BRANCH_HOLIDAY_REASON_MAX_LENGTH () {
        return _branchholidays.BRANCH_HOLIDAY_REASON_MAX_LENGTH;
    },
    get BRANCH_HOURS_MAX_INTERVALS_PER_WEEKDAY () {
        return _branchhours.BRANCH_HOURS_MAX_INTERVALS_PER_WEEKDAY;
    },
    get BRANCH_HOURS_VERSION_CONFLICT () {
        return _cliniccalendarerrors.BRANCH_HOURS_VERSION_CONFLICT;
    },
    get BranchHolidayCreateRequestSchema () {
        return _branchholidays.BranchHolidayCreateRequestSchema;
    },
    get BranchHolidayListQuerySchema () {
        return _branchholidays.BranchHolidayListQuerySchema;
    },
    get BranchHolidayListResponseSchema () {
        return _branchholidays.BranchHolidayListResponseSchema;
    },
    get BranchHolidaySchema () {
        return _branchholidays.BranchHolidaySchema;
    },
    get BranchHoursResponseSchema () {
        return _branchhours.BranchHoursResponseSchema;
    },
    get BranchHoursUpdateRequestSchema () {
        return _branchhours.BranchHoursUpdateRequestSchema;
    },
    get CLINIC_TIME_PATTERN () {
        return _time.CLINIC_TIME_PATTERN;
    },
    get ClinicCalendarDayAvailabilitySchema () {
        return _calendarday.ClinicCalendarDayAvailabilitySchema;
    },
    get ClinicCalendarDayBranchSchema () {
        return _calendarday.ClinicCalendarDayBranchSchema;
    },
    get ClinicCalendarDayQuerySchema () {
        return _calendarday.ClinicCalendarDayQuerySchema;
    },
    get ClinicCalendarDayResponseSchema () {
        return _calendarday.ClinicCalendarDayResponseSchema;
    },
    get ClinicTimeSchema () {
        return _time.ClinicTimeSchema;
    },
    get DOCTOR_AVAILABILITY_BRANCH_INVALID () {
        return _cliniccalendarerrors.DOCTOR_AVAILABILITY_BRANCH_INVALID;
    },
    get DOCTOR_AVAILABILITY_DEFAULT_DURATION_MINUTES () {
        return _doctoravailability.DOCTOR_AVAILABILITY_DEFAULT_DURATION_MINUTES;
    },
    get DOCTOR_AVAILABILITY_LIST_MAX_ITEMS () {
        return _doctoravailability.DOCTOR_AVAILABILITY_LIST_MAX_ITEMS;
    },
    get DOCTOR_AVAILABILITY_MAX_DURATION_MINUTES () {
        return _doctoravailability.DOCTOR_AVAILABILITY_MAX_DURATION_MINUTES;
    },
    get DOCTOR_AVAILABILITY_MAX_INTERVALS () {
        return _doctoravailability.DOCTOR_AVAILABILITY_MAX_INTERVALS;
    },
    get DOCTOR_AVAILABILITY_MAX_INTERVALS_PER_WEEKDAY () {
        return _doctoravailability.DOCTOR_AVAILABILITY_MAX_INTERVALS_PER_WEEKDAY;
    },
    get DOCTOR_AVAILABILITY_MIN_DURATION_MINUTES () {
        return _doctoravailability.DOCTOR_AVAILABILITY_MIN_DURATION_MINUTES;
    },
    get DOCTOR_AVAILABILITY_NOT_A_DOCTOR () {
        return _cliniccalendarerrors.DOCTOR_AVAILABILITY_NOT_A_DOCTOR;
    },
    get DOCTOR_AVAILABILITY_NOT_OWN () {
        return _cliniccalendarerrors.DOCTOR_AVAILABILITY_NOT_OWN;
    },
    get DOCTOR_AVAILABILITY_VERSION_CONFLICT () {
        return _cliniccalendarerrors.DOCTOR_AVAILABILITY_VERSION_CONFLICT;
    },
    get DoctorAvailabilityDocumentSchema () {
        return _doctoravailability.DoctorAvailabilityDocumentSchema;
    },
    get DoctorAvailabilityIntervalInputSchema () {
        return _doctoravailability.DoctorAvailabilityIntervalInputSchema;
    },
    get DoctorAvailabilityIntervalSchema () {
        return _doctoravailability.DoctorAvailabilityIntervalSchema;
    },
    get DoctorAvailabilityListItemSchema () {
        return _doctoravailability.DoctorAvailabilityListItemSchema;
    },
    get DoctorAvailabilityListResponseSchema () {
        return _doctoravailability.DoctorAvailabilityListResponseSchema;
    },
    get DoctorAvailabilityUpdateRequestSchema () {
        return _doctoravailability.DoctorAvailabilityUpdateRequestSchema;
    },
    get DoctorAvailabilityWeekSchema () {
        return _doctoravailability.DoctorAvailabilityWeekSchema;
    },
    get IsoWeekdaySchema () {
        return _time.IsoWeekdaySchema;
    },
    get MINUTES_PER_DAY () {
        return _time.MINUTES_PER_DAY;
    },
    get WeeklyHoursIntervalSchema () {
        return _branchhours.WeeklyHoursIntervalSchema;
    },
    get WeeklyHoursSchema () {
        return _branchhours.WeeklyHoursSchema;
    },
    get addYearsToCalendarDate () {
        return _branchholidays.addYearsToCalendarDate;
    },
    get clinicDayOpeningWindow () {
        return _bookingwarnings.clinicDayOpeningWindow;
    },
    get clinicTimeToMinutes () {
        return _time.clinicTimeToMinutes;
    },
    get evaluateBookingWarnings () {
        return _bookingwarnings.evaluateBookingWarnings;
    },
    get findOverlappingWeekday () {
        return _time.findOverlappingWeekday;
    },
    get isoWeekdayOfDate () {
        return _time.isoWeekdayOfDate;
    },
    get mergeTimeIntervals () {
        return _time.mergeTimeIntervals;
    },
    get resolveBranchHolidayRange () {
        return _branchholidays.resolveBranchHolidayRange;
    },
    get resolveDefaultDurationMinutes () {
        return _bookingwarnings.resolveDefaultDurationMinutes;
    }
});
const _time = require("./time");
const _branchhours = require("./branch-hours");
const _branchholidays = require("./branch-holidays");
const _doctoravailability = require("./doctor-availability");
const _calendarday = require("./calendar-day");
const _bookingwarnings = require("./booking-warnings");
const _cliniccalendarerrors = require("./clinic-calendar-errors");
